import React from 'react';
import { Row, Col } from 'antd';
import GraphDistribution from '../../components/GraphDistribution';
import '../../styles/styles.css'

const COLORS = ['#3C76B9', '#4990E2', '#23446D', '#305C92', '#CCCCCC'];
class GeneralInfoServiceTracker extends React.Component {

  getArrow = (color) => {
    return ({
      width: 0,
      height: 0,
      borderTop: '15px solid transparent',
      borderLeft: `15px solid ${color}`,
      borderBottom: '15px solid transparent',
      position: 'absolute',
      left: '100%',
      zIndex: 1,
      top: 20
    })
  }

  render() {
    const t = this.props.t;
    return (
      <div className='serviceTracker' style={styles.cardContainer}>
        <Row gutter={32} >
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
            <div style={styles.rectangle}>
              <div style={styles.logged}>
                <p style={{ marginBottom: 0, fontSize: 30 }}>{this.props.totalStudents}</p>
                <p style={{ marginBottom: 0, marginTop: 5, fontSize: 21 }}>{this.props.totalStudents > 1 ? t('Total Students') : t('Total Students')}</p>
              </div>
            </div>
          </Col>

          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
            <div style={styles.rectangle}>
              <div style={styles.logged}>
                <p style={{ marginBottom: 0, fontSize: 30 }}>{this.props.totalProjects}</p>
                <p style={{ marginBottom: 0, marginTop: 5, fontSize: 21 }}>{this.props.totalProjects > 1 ? t('Total Projects') : t('Total Projects')}</p>
              </div>
            </div>
          </Col>
        </Row>

        <Row style={styles.rectangle3}>
          <div style={{ width: '100%' }}>
            <p style={styles.title}>{t('Total Number of Project Per Stage')}</p>
          </div>

          <div style={{ width: '100%', padding: '0px 20px 0px 20px' }}>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }}>
              <div style={styles.investigation} >
                <div style={this.getArrow('#5B8EDC')}></div>
                <span style={styles.number}>{this.props.investigation}</span>
                <span style={styles.boxLabel}>Investigation</span>
              </div>

            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }}>
              <div style={styles.preparation} >
                <div style={this.getArrow('#4E7BBD')}></div>
                <span style={styles.number}>{this.props.preparation}</span>
                <span style={styles.boxLabel}>Preparation</span>
              </div>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }}>
              <div style={styles.action} >
                <div style={this.getArrow('#4268A1')}></div>
                <span style={styles.number}>{this.props.action}</span>
                <span style={styles.boxLabel}>Action</span>
              </div>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }}>
              <div style={styles.demonstration} >
                <div style={this.getArrow('#365585')}></div>
                <span style={styles.number}>{this.props.reflection}</span>
                <span style={styles.boxLabel}>Reflection</span>

              </div>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }}>
              <div style={styles.reflection} >
                <span style={styles.number}>{this.props.demonstration}</span>
                <span style={styles.boxLabel}>Demonstration</span>
              </div>
            </Col>
            <Col style={{ height: 150 }} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }}>
              <div style={styles.completed} >
                <div style={{ border: '7px solid #4990E2', borderRadius: '15px', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={styles.numberComplete}>{this.props.totalCompleted}</span>
                  <span style={styles.boxLabelCompelte}>Completed</span>
                </div>
              </div>
            </Col>
          </div>
        </Row>
        <Row style={styles.rectangle2}>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>

            <div style={{ width: '100%' }}>
              <p style={styles.title}>{t('Type of Project')}</p>
            </div>
            <div style={styles.inner}>
              <GraphDistribution data={this.props.distribution} colors={COLORS} percenInLabel={true} />
              <div style={styles.colorbox}>
                {this.props.categoryList && this.props.categoryList.map((category, i) =>
                  <p><div className="circle" style={{ backgroundColor: COLORS[i] }} /> {t(category)}</p>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div >
    )
  }
}

export default GeneralInfoServiceTracker;

const styles = {
  logged: {
    fontSize: '24px',
    color: 'white',
    fontWeight: 600,
    textAlign: 'center',
    lineHeight: '33px',
    height: '192px',
    width: '192px',
    borderRadius: '50%',
    backgroundColor: '#4A90E2',
    marginLeft: 20,
    marginRight: 20,
    paddingTop: 45,
    boxShadow: '0 6px 16px 0 rgba(0,77,182,0.38)',
    display: 'inline-block'
  },

  container: {
    margin: '0px 20px 20px 20px',
    fontFamily: 'Muli'
  },
  rectangle: {
    display: 'flex',
    height: '314px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 1px 3px 1px rgba(119,151,178,0.16)'
  },

  rectangle2: {
    display: 'flex',
    flexDirection: 'column',
    height: '493px',
    marginBottom: '25px',
    marginTop: '25px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 1px 3px 1px rgba(119,151,178,0.16)'
  },
  rectangle3: {
    display: 'flex',
    flexDirection: 'column',
    height: '300px',
    marginBottom: '25px',
    marginTop: '25px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 1px 3px 1px rgba(119,151,178,0.16)'
  },


  investigation: {
    backgroundColor: '#4990E2',
    height: 150,
    borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    color: '#FFFFFF',
    fontSize: '30px',
    fontWeight: 800,
    lineHeight: '20px',
    textAlign: 'center'
  },
  preparation: {
    backgroundColor: '#3E7CC3',
    height: 150,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  action: {
    backgroundColor: '#3669A6',
    height: 150,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  demonstration: {
    backgroundColor: '#2C5689',
    height: 150,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  reflection: {
    backgroundColor: '#23446D',
    height: 150,
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },

  completed: {
    height: '100%',
    padding: 20,
    backgroundColor: '#FFFFFF'
  },

  title: {
    fontSize: '20px',
    color: '#485465',
    fontWeight: 600,
    marginLeft: 30
  },
  boxLabel: {
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    color: '#FFFFFF',
    fontSize: '17px',
    fontWeight: '600',
    lineHeight: '29px',
    textAlign: 'center'
  },

  number: {
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    width: '36px',
    color: '#FFFFFF',
    fontSize: '30px',
    fontWeight: 800,
    lineHeight: '20px',
    textAlign: 'center',
    width: 'fix-content',
    marginBottom: 10
  },
  boxLabelCompelte: {
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    color: '#5B8EDC',
    fontSize: '17px',
    fontWeight: '600',
    lineHeight: '29px',
    textAlign: 'center'
  },

  numberComplete: {
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    width: '36px',
    color: '#5B8EDC',
    fontSize: '30px',
    fontWeight: 800,
    lineHeight: '20px',
    textAlign: 'center',
    width: 'fit-content'
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    width: '100%'
  },

  colorbox: {
    fontSize: '16px'
  },
  dounatChart: {
    marginBottom: '25px',
    marginTop: '25px'
  },

  cardContainer: {
    marginLeft: '25px',
    marginRight: '25px',
    marginBottom: '25px',
    marginTop: '25px'
  }
}



// WEBPACK FOOTER //
// ./src/components/GeneralInfoServiceTracker/index.jsx